import { UnitsState } from './data/state/units.state';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { RouteReuseStrategy, Router } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicGestureConfig } from '../app/utils/IonicGestureConfig';
import { AuthorizationInterceptor } from './interceptors/authorization.interceptor';
import * as SentryAngular from '@sentry/angular-ivy';

// NGXS
import { NgxsModule } from '@ngxs/store';
//import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
// import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
// States
import { PickupState } from './data/state/pickup.state';
import { CheckpointState } from './data/state/checkpoint.state';
import { SettingsState } from './data/state/settings.state';
import { UserPrivilegesState } from './data/state/user-privileges.state';
import { UserAppLocationState } from './data/state/user-app-location.state';

import { environment } from 'src/environments/environment';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({ mode: 'md' }),
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient, SentryAngular.TraceService],
      },
    }),
    NgxsModule.forRoot(
      [PickupState, CheckpointState, SettingsState, UnitsState, UserPrivilegesState, UserAppLocationState],
      { developmentMode: !environment.production }
    ),
    // NgxsReduxDevtoolsPluginModule.forRoot(),
    //NgxsLoggerPluginModule.forRoot(),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true,
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: IonicGestureConfig,
      multi: true,
    },
    {
      provide: SentryAngular.TraceService,
      deps: [Router],
    },
    {
      provide: ErrorHandler,
      useValue: SentryAngular.createErrorHandler(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
